import useOnlineStatus from '@rehooks/online-status';
import MultiField from 'Components/Forms/MultiField';
import { useEffect, useState } from 'react';
import api from 'Services/api';
import valueStore from 'Services/valueStore';

const TrainingList = ({ training, push, remove, required = false, ...props }) => {
  const isOnline = useOnlineStatus();
  const [suggestions, setSuggestions] = useState([]);

  const sync = () => {
    const getTraining = async () => await api.fetchTraining();

    getTraining().then(async (trainingList) => {
      const values = trainingList.map((item) => item.description);
      setSuggestions(values);
      await valueStore.set(`training`, values);
    });
  };

  useEffect(() => {
    const loadTraining = async () => {
      if (isOnline) {
        sync();
      } else {
        const storedTraining = await valueStore.getArray(`training`);
        setSuggestions(storedTraining || []);
      }
    };

    loadTraining();
  }, [isOnline]);

  return (
    <MultiField
      name="training"
      values={training}
      push={push}
      remove={remove}
      label="What Training is needed?"
      placeholder="Add new training"
      required={required}
      suggestions={suggestions}
      isSortable={false}
      valueKey="description"
    />
  );
};

export default TrainingList;
